import React from 'react'

import type { NotificationContentBlock } from '@library/api-menu-experience'
import { Notification } from '@library/menu-page'

type NotificationContentBlockWrapperProps = {
  contentBlock: NotificationContentBlock
}

export const NotificationContentBlockWrapper = ({
  contentBlock,
}: NotificationContentBlockWrapperProps) => <Notification contentBlock={contentBlock} />
